import {
  Image,
  Button,
  useDisclosure,
  Drawer,
  DrawerBody,
  DrawerOverlay,
  DrawerContent,
  DrawerCloseButton,
  Divider,
  Flex,
  IconButton,
  Menu,
  MenuButton,
  MenuList,
  MenuItem,
} from '@chakra-ui/react';
import { HamburgerIcon, ChevronDownIcon } from '@chakra-ui/icons';
import { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
// import companyMiniLogo from '../images/hke-logo-sm.png';
import { useTranslation } from 'react-i18next';

const Header = () => {
  const { isOpen, onOpen, onClose } = useDisclosure();
  const { t, i18n } = useTranslation();
  const location = useLocation();
  const isMainPage = location.pathname === '/' || location.pathname === '/tour';
  const navigate = useNavigate();

  const changeLanguage = (lang) => {
    i18n.changeLanguage(lang);
  };

  useEffect(() => {
    const stickyNav = document.getElementById('sticky-navbar');
    if (stickyNav) {
      stickyNav.style.visibility = 'visible';
      stickyNav.style.opacity = 1;
      stickyNav.style.transform = 'translateY(0)';
    }
  }, []);

  const isDecember = new Date().getMonth() === 11;
  const miniLogoFilename = 'logo-sm.png';
  const miniLogoPath = isDecember ? `/images/Christmas/${miniLogoFilename}` : `/images/${miniLogoFilename}`;

  return (
    <>
      {/* Sticky Navbar */}
      <Flex
        id="sticky-navbar"
        position="fixed"
        top="0"
        left="0"
        right="0"
        bg="white"
        boxShadow="lg"
        zIndex="1000"
        justify="space-between"
        align="center"
        px={4}
        py={3}
      >
        <Image src={miniLogoPath} alt="HKE Learning" h="50px" />
        <Flex ml="auto" align="center" gap={6}>
          <Flex as="ul" listStyleType="none" gap={8} display={{ base: 'none', md: 'flex' }}>
            {!isMainPage && (
              <Button as="a" href="/" variant="link">
                {t('website.navbar.home')}
              </Button>
            )}
            {isMainPage && (
              <>
                <Button variant="link" onClick={() => document.getElementById('header').scrollIntoView()}>
                  {t('website.navbar.home')}
                </Button>
                {/* <Button variant="link" onClick={() => document.getElementById('about').scrollIntoView()}>
                  {t('website.navbar.aboutUs')}
                </Button> */}
                <Button variant="link" onClick={() => document.getElementById('services').scrollIntoView()}>
                  {t('website.navbar.services')}
                </Button>
                <Button variant="link" onClick={() => document.getElementById('resources').scrollIntoView()}>
                  {t('website.navbar.resources')}
                </Button>
                <Button variant="link" onClick={() => document.getElementById('team').scrollIntoView()}>
                  {t('website.navbar.ourTeam')}
                </Button>
                <Button variant="link" onClick={() => document.getElementById('contact').scrollIntoView()}>
                  {t('website.navbar.contact')}
                </Button>
                <Button variant="outline" colorScheme="cyan" size="sm" onClick={() => navigate('/login')}>
                  {t('website.navbar.login')}
                </Button>
              </>
            )}
          </Flex>

          {/* Language Selector */}
          <Flex display={{ base: 'none', md: 'flex' }}>
            <Menu>
              <MenuButton
                as={Button}
                rightIcon={<ChevronDownIcon />}
                colorScheme="gray"
                variant="outline"
                size="sm"
              >
                {i18n.language === 'en' ? 'English' : 'Svenska'}
              </MenuButton>
              <MenuList>
                <MenuItem onClick={() => changeLanguage('en')}>English</MenuItem>
                <MenuItem onClick={() => changeLanguage('sv')}>Svenska</MenuItem>
              </MenuList>
            </Menu>
          </Flex>
        </Flex>

        <IconButton
          aria-label="Open Menu"
          icon={<HamburgerIcon />}
          onClick={onOpen}
          display={{ base: 'block', md: 'none' }}
        />
      </Flex>

      {/* Drawer for mobile menu */}
      <Drawer isOpen={isOpen} placement="right" onClose={onClose}>
        <DrawerOverlay />
        <DrawerContent>
          <DrawerCloseButton />
          <DrawerBody>
            <Flex as="ul" direction="column" listStyleType="none" gap={4}>
              <Button as="a" href="/" onClick={onClose} variant="link">
                {t('website.navbar.home')}
              </Button>
              {isMainPage && (
                <>
                  {/* <Button variant="link" onClick={() => { onClose(); document.getElementById('about').scrollIntoView(); }}>
                    {t('website.navbar.aboutUs')}
                  </Button> */}
                  <Button variant="link" onClick={() => { onClose(); document.getElementById('services').scrollIntoView(); }}>
                    {t('website.navbar.services')}
                  </Button>
                  <Button variant="link" onClick={() => { onClose(); document.getElementById('resources').scrollIntoView(); }}>
                    {t('website.navbar.resources')}
                  </Button>
                  <Button variant="link" onClick={() => { onClose(); document.getElementById('team').scrollIntoView(); }}>
                    {t('website.navbar.ourTeam')}
                  </Button>
                  <Button variant="link" onClick={() => { onClose(); document.getElementById('contact').scrollIntoView(); }}>
                    {t('website.navbar.contact')}
                  </Button>
                  <Button colorScheme="cyan" size="sm" onClick={() => navigate('/login')} variant="outline">
                    {t('website.navbar.login')}
                  </Button>
                </>
              )}
              <Divider />
              <Button
                variant="link"
                onClick={() => { onClose(); changeLanguage('en'); }}
                isActive={i18n.language === 'en'}
              >
                English
              </Button>
              <Button
                variant="link"
                onClick={() => { onClose(); changeLanguage('sv'); }}
                isActive={i18n.language === 'sv'}
              >
                Svenska
              </Button>
            </Flex>
          </DrawerBody>
        </DrawerContent>
      </Drawer>
    </>
  );
};

export default Header;